import { normalizedCanaryPercentage, getRandomPercentage } from '../helpers/canaryUtils.js';
import { isLocalStorageAvailable, getItem, setItem } from '../helpers/localStorage.js';

const CANARY_LOCAL_STORAGE_KEY = 'mfs-canary';
class CanaryManager {
    isInCanary(mfName, canaryMetaData) {
        if (!canaryMetaData || !isLocalStorageAvailable()) {
            return false;
        }
        const canaryPercentage = this.getCanaryPercentage(canaryMetaData);
        const userCanaryExperimentalPercentage = this.getAndSetUserCanaryExperimentalGroup(mfName, canaryMetaData.version);
        return canaryPercentage >= userCanaryExperimentalPercentage;
    }
    getCanaryPercentage(canaryMetaData) {
        const { startTimestamp, endTimestamp } = canaryMetaData;
        const totalCanaryDuration = new Date(endTimestamp).valueOf() - new Date(startTimestamp).valueOf();
        const durationFromCanaryStart = new Date().valueOf() - new Date(startTimestamp).valueOf();
        const percentage = Math.round((durationFromCanaryStart / totalCanaryDuration) * 100);
        return normalizedCanaryPercentage(percentage);
    }
    getAndSetUserCanaryExperimentalGroup(mfName, version) {
        const canariesExperimentalPercentage = getItem(CANARY_LOCAL_STORAGE_KEY) || {};
        let canaryPercentage = canariesExperimentalPercentage[mfName]?.[version];
        if (canaryPercentage) {
            return canaryPercentage;
        }
        canaryPercentage = getRandomPercentage();
        canariesExperimentalPercentage[mfName] = { [version]: canaryPercentage };
        setItem(CANARY_LOCAL_STORAGE_KEY, canariesExperimentalPercentage);
        return canaryPercentage;
    }
}

export { CANARY_LOCAL_STORAGE_KEY, CanaryManager as default };
